import React from 'react';
import Portfolio from './pages/Portfolio';
import './App.css';

function App() {
  return (
    <div className="App">
      <Portfolio />
    </div>
  );
}

export default App;
